<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>

            <b-card-body v-if="!model.viewResult">
                 <div class="row" style="margin-top: 10px">
                    <div class="col-md-12 text-center">
                        <img src="@/assets/activate.png" />
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Vamos a activar tu tarjeta</label> 
                    </div>
                </div>  
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Por favor ingresa los 4 últimos dígitos de tu tarjeta</label> 
                    </div>
                </div>   
                 <div class="row form-group">
                      <div class="col-md-12 text-center">
                        <pincode-input v-model="model.LastCardNumbers" ref="pincode-old-pin" secure autocomplete="off"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" @click="aceptar">Aceptar</b-button>                        
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" @click="goBack">Cancelar</b-button>
                    </div>
                </div>
            </b-card-body>

            <b-card-body v-if="model.viewResult">
                <div class="row">
                <div class="col-md-12 text-center">
                    <base-alert :type="resultado.Tipo">
                        <span class="alert-inner--icon" style="font-size: 60px;">
                            <i :class="resultado.Icono"></i>
                        </span><br>
                        <span class="alert-inner--text" v-html="resultado.Texto"></span>
                    </base-alert>
                </div>
                <div class="col-md-12">
                    <div class="row text-center" style="margin-top: 10px">
                        <div class="col-md-12">
                            <b-button class="btn btn-lg btn-danger" @click="goBack">Volver</b-button>
                        </div>
                    </div>
                </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import PincodeInput from 'vue-pincode-input';

    export default {
        components: { 
            "pincode-input": PincodeInput
        },
        data(){
            return{
                model: {   
                    LastCardNumbers: '',
                    viewResult: false,
                },
                resultado: {
                    Texto: "prueba",
                    Tipo: "success",
                    Icono: "fa fa-fw fa-thumbs-up"
                }
            }
        },
        methods: {
            aceptar() {
            let context = this;

            // -- Ultimos numeros de la tarjeta
            if (context.model.LastCardNumbers == "") 
            {
                notificationHelpers.showWarning("Advertencia!", "Debe ingresar los ultimos 4 números de la tarjeta.", context);
                return;
            }

            this.$validator.validate().then(valid => {
            if (valid) {
            axiosHelpers.axiosPost(
                "Mastercard/ActivateAccountCard",
                {
                LastCardNumbers: context.model.LastCardNumbers,
                DeviceID: "",
                IsAndroid: false
                },
                this,
                function(data) {
                context.model.viewResult = true;
                if (data.ResponseVM.Result)
                {
                    let msg =
                    "¡Listo! Activamos tu tarjeta" +
                    "<br/>" +
                    "Ya podes utilizar tu tarjeta Mastercard prepaga en miles de establecimientos y servicios online de todo el mundo.";

                    context.resultado = {
                        Texto: msg,
                        Tipo: "success",
                        Icono: "fa fa-fw fa-thumbs-up",
                    };
                }
                else
                {
                    let msg =
                    "¡Ups! No pudimos activar tu tarjeta" +
                    "<br/>" +
                    "No hemos podido procesar correctamente la activación de tu tarjeta. Error: Solicitud en estado incorrecto";

                    context.resultado = {
                        Texto: msg,
                        Tipo: "danger",
                        Icono: "fa fa-fw fa-thumbs-down",
                    };
                }
            }
        );
        } 
        else
        {
            notificationHelpers.showWarning(
                "Advertencia!",
                "Verifique todos los campos",
                context
            );
        }
        });
        },
        goBack()
        {
            let context = this;
            context.$router.push("dashboard");
        },
        cancelar()
        {
            let context = this;
            context.$router.push(this.routeGoToAfterFinish);
            }
        }
    }
</script>